export const CROCHET_TYPES = ['chain-up', 'chain-center', 'slip-stitch', 'single-crochet-x', 'single-crochet-crosshair', 'half-double-crochet'] as const;

export type CrochetType = (typeof CROCHET_TYPES)[number];

export type RingCrochet = {
    /** Stable identifier — generated at placement time, surviving add/remove on the ring. */
    id: string;
    type: CrochetType;
    /** Radians, applied around the snap anchor; composes on top of the parent/ring rotation. */
    rotation: number;
    /** Anisotropic scale; defaults to {1,1}. Effective range [0.5, 2]. When the icon has 2 positional parents,
     *  the solver overrides this with a uniform Procrustes-derived scale (this stored value is preserved
     *  and resumes once the icon drops back to ≤1 positional parent). */
    scale: { x: number; y: number };
    /** Per-instance snap anchor in bbox-local fractional (u, v).
     *  When undefined, falls back to CROCHET_ICON_DATA[type].snapAnchor. */
    snapAnchor?: { u: number; v: number };
};

export type GridCrochet = {
    type: CrochetType;
    position: { row: number, column: number };
};


/** Fixed baseline used by legacy multi-anchor proportions. Per-type visual bounds live in CROCHET_ICON_DATA[type].bbox. */
export const CROCHET_NOMINAL_HEIGHT = 10;

/** Bbox / OBB side index. Convention (clockwise from inner edge):
 *  0 = inner (v=0), 1 = u-high (u=1), 2 = outer (v=1), 3 = u-low (u=0). */
export type Side = 0 | 1 | 2 | 3;
